import { z } from 'zod';

import { StepInstanceId, WorkflowInstanceId } from '../BrandedIds';
import { zodBrandedString } from '../utils/Zod';

export const WorkflowStepTaskContext = z.object({
  type: z.literal('workflowStepTask'),
  workflowInstanceId: zodBrandedString<WorkflowInstanceId>(),
  stepInstanceId: zodBrandedString<StepInstanceId>(),
});
export type WorkflowStepTaskContext = z.infer<typeof WorkflowStepTaskContext>;
